export enum TransactionEventIdentificationEnum {
  PaidOrderByMember = 1,
  PaidOrderByIndication = 2,
  AnsweredSurveyByMember = 3,
  PointsConverted = 4,
  PointsOrCashCanceled = 5,
  RegisterAdditionalMemberAccountData = 6,
  InitialImport = 7,
  LevelChangeReward = 8,
  CustomerBirthday = 9,
  ManualCredit = 10,
  ManualDebit = 11,
  PaidOrderByIndicationWithCashReward = 12,
  CashConverted = 13,
  PointsOrCashCanceledForReferencedOrder = 14,
  PointsOrCashExpired = 15,
  PointsOrCashExpiredByInactivity = 16
}